import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureSection from './components/FeatureSection';
import CTASection from './components/CTASection';
import BlogSection from './components/BlogSection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import FooterSection from './components/FooterSection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'AllChinaBuy.works',
  url: 'https://allchinabuy.works',
  description: 'The ultimate China sourcing spreadsheet hub. Helping ecommerce sellers discover winning products through structured, verified supplier data updated weekly.',
  logo: {
    '@type': 'ImageObject',
    url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg',
  },
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'AllChinaBuy.works',
  url: 'https://allchinabuy.works',
  description: 'Discover verified AllChinaBuySpreadsheet lists, winning products, and sourcing strategies for ecommerce sellers worldwide.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <Navbar isScrolled={isScrolled} />
      <HeroSection />
      <TrustSection />
      <CategoryGrid />
      <FeatureSection />
      <CTASection />
      <BlogSection />
      <TestimonialSection />
      <FAQSection />
      <FooterSection />
    </main>
  );
}